import { hash } from "rsvp";
import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class NetworksRoute extends Route {
  @service availableServices;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    this.availableServices.requireAccessTo(this, "networking");
  }

  model() {
    let { project } = this.modelFor("organization");
    return hash({
      project,
      networks: project.get("networks"),
    });
  }
}
